var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalRemanejamento',{attrs:{"modal-id":"modal-remanejar-servico","servico":_vm.servico,"registro-id":_vm.servico_id},on:{"remanejado":function($event){return _vm.$router.go(-1)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }